import React from "react";
import { useTranslation } from "react-i18next";
import { ProgramCategory } from "../../../types";
import {
  Modal,
  ModalBody,
  ModalClose,
  ModalHeader,
  ModalTitle,
} from "../../UI/Modal";
import ProgramCategoryForm from "../ProgramCategoryForm";

type Props = {
  category?: ProgramCategory;
  isOpen: boolean;
  isSubmitting: boolean;
  defaultOrderNumber: number | null;
  onClose: () => void;
  onSubmit: (data: ProgramCategory) => void;
};

const ProgramCategoryModal: React.FC<Props> = ({
  category,
  isOpen,
  isSubmitting,
  defaultOrderNumber,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <Modal show={isOpen} onClose={() => {}}>
      <ModalHeader>
        <ModalTitle>
          {category
            ? t("components.categoryModal.typeEdit")
            : t("components.categoryModal.typeNew")}
        </ModalTitle>
        <ModalClose onClose={onClose}>x</ModalClose>
      </ModalHeader>
      <ModalBody>
        <ProgramCategoryForm
          isSubmitting={isSubmitting}
          onSubmit={(data: any) => onSubmit(data)}
          defaultOrderNumber={defaultOrderNumber}
          onCancel={onClose}
          category={category}
        />
      </ModalBody>
    </Modal>
  );
};

export default ProgramCategoryModal;
